import { visitorConstants } from "../../constants";

export function visitor(state={}, action) {
  switch (action.type) {
    case visitorConstants.GET_OR_CREATE_ID:
      return { id: action.payload.id }
    default:
      return state;
  }
}